import { useState, useEffect } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { useAuth } from "src/contexts/AuthContext";

export type CreditMemoLookup = {
  creditMemoId: string;
  creditMemoTranId: string;
  customerName: string;
  subsidiary: string;
  subsidiaryId: string;
  total: number;
  memo: string;
  found: boolean;
  status?: string;
};

export const useCreditMemoLookup = (tranIds: string[]) => {
  const [creditMemos, setCreditMemos] = useState<CreditMemoLookup[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const fetchDetails = async (ids: string[]) => {
    if (ids.length === 0) {
      setCreditMemos([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(
        `${API_URL}/netsuite/credit-memo-lookup?tranIds=${encodeURIComponent(ids.join(","))}`
      );
      const data = await checkResponse(response);
      setCreditMemos(data);
    } catch (err) {
      console.error("Error fetching credit memo details:", err);
      setError("Failed to fetch credit memo details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetails(tranIds);
  }, [tranIds]);

  return {
    creditMemos,
    loading,
    error,
    refetch: () => fetchDetails(tranIds),
  };
};
